/* assets/akf-build-router.js */
/* Intercepts /build/* on Shopify, calls Rails to get/create the product, then redirects to /products/<handle>. */
(function(){
  const WAIT = 50;

  function ready(fn){
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function untilAKF(cb){
    if (window.AKF) cb();
    else setTimeout(()=>untilAKF(cb), WAIT);
  }

  function parseBuildPath(){
    // /build/<category>/<size>  e.g. /build/merv/30x20x1
    const m = location.pathname.match(/^\/build\/([^/]+)\/([^/]+)$/i);
    if(!m) return null;
    const category = decodeURIComponent(m[1]);
    const size     = decodeURIComponent(m[2]); // "30x20x1"
    const qs = new URLSearchParams(location.search);
    const quality = qs.get('quality'); // optional
    return { category, size, quality };
  }

  async function callRails(info){
    const base = (window.AKF && AKF.BASE) || 'https://stark-chamber-2909.herokuapp.com';
    const urls = [
      `${base}/build/${encodeURIComponent(info.category)}/${encodeURIComponent(info.size)}.json${info.quality ? `?quality=${encodeURIComponent(info.quality)}` : ''}`,
      `${base}/dynamic_product.json?category=${encodeURIComponent(info.category)}&size=${encodeURIComponent(info.size)}${info.quality ? `&quality=${encodeURIComponent(info.quality)}` : ''}`
    ];

    for (const url of urls) {
      try {
        const res = await fetch(url, { headers: { 'Accept':'application/json' }, credentials: 'omit' });
        if (!res.ok) continue;
        const data = await res.json();
        const handle =
          data.handle ||
          (data.product && data.product.handle) ||
          (data.result && data.result.handle);
        if (handle) return handle;
      } catch(e) {
        // try next URL
      }
    }
    throw new Error('Build API did not return a product handle.');
  }

  async function run(){
    const info = parseBuildPath();
    if (!info) return; // not on /build/* — do nothing

    // Minimal progress UI
    const box = document.createElement('div');
    box.style.cssText = 'max-width:680px;margin:1.5rem auto;padding:1rem;border:1px solid #eee;border-radius:8px';
    box.innerHTML = `
      <h2>Building your filter…</h2>
      <p>Size: <strong>${info.size}</strong> • Category: <strong>${info.category}</strong>${info.quality ? ` • MERV: <strong>${info.quality}</strong>` : ''}</p>
      <p>Please wait…</p>`;
    document.body.prepend(box);

    try{
      const handle = await callRails(info);
      location.replace(`/products/${encodeURIComponent(handle)}`);
    } catch(err){
      console.error('[AKF] build router error:', err);
      box.innerHTML += `<p style="color:#b00">Sorry, we couldn’t create that size automatically.<br>
      <small>${String(err.message || err)}</small></p>`;
    }
  }

  ready(()=>untilAKF(run));
})();
